function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Body1 } from "@xo-union/tk-ui-typography";
import RetakeQuizModal from "../RetakeQuizModal/index.js";
import styles from "./styles.css";
import { redirect } from "../../utils/common.js";
export default function RetakeBanner(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    onOpenModal = _ref.onOpenModal,
    quizUrl = _ref.quizUrl;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenModal = _useState2[0],
    setIsOpenModal = _useState2[1];
  var handleOpenModal = useCallback(function () {
    onOpenModal();
    setIsOpenModal(true);
  }, [onOpenModal]);
  var handleCloseModal = useCallback(function () {
    setIsOpenModal(false);
  }, []);
  var handleRetakeQuiz = useCallback(function () {
    handleCloseModal();
    redirect(quizUrl);
  }, [quizUrl, handleCloseModal]);
  return /*#__PURE__*/React.createElement("section", {
    className: styles['tk-retake-banner']
  }, /*#__PURE__*/React.createElement(Body1, {
    as: "p",
    className: styles['tk-retake-baner--paragraph']
  }, title), /*#__PURE__*/React.createElement("button", {
    color: "tertiary",
    className: styles['tk-retake-baner--anchor'],
    onClick: handleOpenModal
  }, subtitle), /*#__PURE__*/React.createElement(RetakeQuizModal, {
    isOpen: isOpenModal,
    onRetakeQuiz: handleRetakeQuiz,
    onCloseModal: handleCloseModal
  }));
}
process.env.NODE_ENV !== "production" ? RetakeBanner.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  onOpenModal: PropTypes.func,
  quizUrl: PropTypes.string
} : void 0;
RetakeBanner.defaultProps = {
  quizUrl: 'https://qa-beta.theknot.com/stylematch-wedding-dress-quiz',
  onOpenModal: function onOpenModal() {}
};